<!-- Teenuste "Küsi pakkumine" vorm -->
<template>
  <div class="offer-link clickable" @click="form = true">
    <div>{{$t('pakkumine')}}</div>
    <v-icon>mdi-chevron-right</v-icon>
  </div>
  <v-dialog v-model="form" max-width="500" :fullscreen="xs" transition="none">
    <v-card>
      <v-toolbar color="white" :title="getTitle(service)">
        <v-btn icon="mdi-close" @click="form = false; handleReset()"></v-btn>
      </v-toolbar>
      <form class="pa-5" @submit.prevent="submit" id="request-form">
        <v-text-field
            variant="outlined"
            v-model="name.value.value"
            :error-messages="name.errorMessage.value"
            :label="$t('nimi')"
        ></v-text-field>
        <v-text-field
            variant="outlined"
            v-model="ettevote.value.value"
            :label="$t('ettev')"
        ></v-text-field>
        <v-text-field
            variant="outlined"
            v-model="phone.value.value"
            :error-messages="phone.errorMessage.value"
            :label="$t('tel')"
        ></v-text-field>
        <v-text-field
            variant="outlined"
            v-model="email.value.value"
            :error-messages="email.errorMessage.value"
            :label="$t('email')"
        ></v-text-field>
        <v-number-input
            controlVariant="stacked"
            :label="$t('osalejate_arv')"
            v-model="participants.value.value"
            variant="outlined"
            :error-messages="participants.errorMessage.value"
            :min="1"
            class="participants-input"
        ></v-number-input>
        <v-select
            variant="outlined"
            menu-icon="mdi-chevron-down"
            v-model="select_lang.value.value"
            :items="items"
            :error-messages="select_lang.errorMessage.value"
            :label="$t('labiviimise_keel')"
        ></v-select>
        <v-date-input
            :label="$t('toimumisaeg')"
            prepend-icon=""
            prepend-inner-icon="$calendar"
            v-model="date.value.value"
            :error-messages="date.errorMessage.value"
            variant="outlined"
            mode-icon="mdi-chevron-down"
            color="eraklient"
        ></v-date-input>
        <v-text-field
          v-model="time.value.value"
          :active="menu2"
          variant="outlined"
          :label="$t('aeg')"
          :error-messages="time.errorMessage.value"
          prepend-inner-icon="mdi-clock-time-four-outline"
          readonly
          >
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            activator="parent"
            transition="scale-transition"
          >
          <v-time-picker
              v-if="menu2"
              v-model="time.value.value"
              :title="$t('aeg')"
              color="eraklient"
              format="24hr"
              min="8:00"
              max="20:00"
              full-width
          ></v-time-picker>
          </v-menu>
        </v-text-field>
        <v-select
            variant="outlined"
            menu-icon="mdi-chevron-down"
            v-model="select_city.value.value"
            :items="cities"
            :error-messages="select_city.errorMessage.value"
            :label="$t('toimumiskoht')"
        ></v-select>
        <v-textarea
            variant="outlined"
            v-model="message.value.value"
            :label="$t('sonum_valik')"
        ></v-textarea>
        <input type="text" name="honeypot" id="honeypot" style="display: none;" v-model="honeypot.value.value">
        <v-btn color="eraklient" class="d-flex w-100" type="submit" value="Submit">{{ $t('saada') }}</v-btn>
      </form>
    </v-card>
  </v-dialog>
</template>

<script setup>
import {useI18n} from "vue-i18n"
import {useField, useForm} from "vee-validate"
import {ref, computed} from "vue"
import {toast} from "vue3-toastify"
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VNumberInput, VTimePicker } from 'vuetify/components'
import { useDisplay } from 'vuetify'
import { useRoute } from 'vue-router'
const { xs } = useDisplay()
const { t, locale } = useI18n()
const route = useRoute()
const form = ref(false)
const menu2 = ref(false)
const props = defineProps(['service'])
import { useStore } from 'vuex'

const { handleSubmit, handleReset } = useForm({
  validationSchema: {
    name (value) {
      if (value?.length > 1) return true
      return t('sisesta_nimi')
    },
    email (value) {
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) return true
      return t('sisesta_email')
    },
    phone (value) {
      if (value?.length > 6 && /[0-9-]+/.test(value)) return true
      return t('sisesta_tel')
    },
    select_lang (value) {
      if (value) return true
      return t('sisesta_keel')
    },
    participants (value) {
      if (value) return true
      return t('sisesta_osalejad')
    },
    select_city (value) {
      if (value) return true
      return t('kohtumiskoht')
    },
    date (value) {
      if (value) return true
      return t('sisesta_aeg')
    },
    time (value) {
      if (value) return true
      return t('sisesta_aeg')
    }
  },
})

const name = useField('name')
const ettevote = useField('ettevote')
const phone = useField('phone')
const email = useField('email')
const select_lang = useField('select_lang')
const select_city = useField('select_city')
const message = useField('message')
const participants = useField('participants')
const date = useField('date')
const honeypot = useField('honeypot')
const store = useStore()
const time = useField('time')


const cities = computed(() => {
  return [
    t('stuudio'),
    t('Tartu'),
    t('Tallinn'),
    t('Pärnu'),
    t('Rakvere'),
    t('Valga'),
    t('Muu')
  ];
})

const items = computed(() => {
  return [
    t("eesti"),
    t("inglise"),
    t("vene"),
    t("ukraina"),
  ];
})

const submit = handleSubmit(async values => {
  if (honeypot.value.value) {
    toast.success(t('mess_succ'));
    handleReset();
    form.value = false;
    return
  }
  try {
    const newValues = {
      ...values,
      date: store.getters.formatDate(date.value.value),
      subject: buildSubject()
    };
    const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newValues)
    });

    const data = await response.text();
    console.log(data);
    if (response.ok) {
      toast.success(t('offer_succ'));
      handleReset();
      form.value = false;
    }
    else {
      toast.error(t('offer_err'));
    }
  }
  catch (error) {
    console.error('There has been a problem with your fetch operation:', error);
  }
})

const getServiceTitle = (content) => {
  if (!content) return '';

  const candidates = [
    content.title,
    content.header,
    content.name,
    content.title_et,
    content.header_et,
    content.name_et,
    content.title_en,
    content.header_en,
    content.name_en,
    content.title_ru,
    content.header_ru,
    content.name_ru,
  ];

  const resolved = candidates.find((value) => typeof value === 'string' && value.trim());
  return resolved ? resolved.trim() : '';
};

const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '');

const getCategoryLabel = () => {
  const candidates = [
    props?.service?.category,
    props?.service?.service_type,
    props?.service?.type,
    props?.service?.section,
    route?.meta?.sectionName,
    route?.meta?.category,
  ];

  for (const candidate of candidates) {
    const value = normalizeText(candidate);
    if (value) return value;
  }

  const segment = (route?.path || '').split('/').filter(Boolean).at(-1) || '';
  const routeLabels = {
    uritused: t('tutvu_uritus'),
    huviringid: t('huviringid'),
    lohnastuslahendused: t('lõhnastuslahendused'),
    meeskonnakoolitused: t('meeskonnakoolitused'),
    ninatrenn: t('ninatrenn'),
    kinkekaardid: t('kinkekaardid'),
  };

  return routeLabels[segment] || routeLabels[segment?.toLowerCase?.()] || '';
};

const buildSubject = () => {
  const serviceTitle = getServiceTitle(props.service);
  const eventRoute = typeof route?.path === 'string' ? route.path.toLowerCase() : '';
  const eventName = typeof route?.name === 'string' ? route.name.toLowerCase() : '';
  const serviceType = typeof props?.service?.type === 'string' ? props.service.type.toLowerCase() : '';
  const serviceCategory = typeof props?.service?.category === 'string' ? props.service.category.toLowerCase() : '';
  const isEventProgramContext = eventRoute.includes('uritused') || eventName.includes('uritused') || serviceType.includes('uritused') || serviceCategory.includes('uritused');

  if (isEventProgramContext) {
    return serviceTitle ? `Ürituste programmid - ${serviceTitle}` : 'Ürituste programmid';
  }

  const categoryLabel = getCategoryLabel();

  if (serviceTitle && categoryLabel && categoryLabel !== serviceTitle) {
    return `${categoryLabel} - ${serviceTitle}`;
  }

  return serviceTitle || 'Küsi pakkumine';
};

const getTitle = (content) => {
  return (locale.value === 'en' && content?.title_en) ? content.title_en : (locale.value === 'ru' && content?.title_ru) ? content.title_ru : (content?.title || content?.header || content?.name || '');
};
</script>

<style scoped>
.offer-link {
  display: inline-flex;
  align-items: center;
  color: #3b71f7;
  text-transform: uppercase;
  font-weight: 600;
}

.offer-link div:hover {
  text-decoration: underline;
}

.participants-input {
  width: 200px !important;
}

@media (max-width: 650px) {
  .offer-link {
    padding-bottom: 20px;
  }
}
</style>